module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABUElEQVR4nO2Y4U2DUBSFz5nAjuAG4gTiJOIGbiCdQDeQTlLeBMUNOkKdAA/hH/BQXkgvxvslX86vJvdrUpJC/HE8wBoPsMYDrJkNaNv2TVMA2EkLLvKd5F47CeUkOv6oybENakU8akdQjtDxBYAPuSWeSVYYEAuoADzJLXEgWWBALKAG8CC3RCCZY4AHXJFAD7Al0ANsCfQAWwI9wJZAD7Al0ANsCfQAWwITAg6ygi0F+n+HgQkBe5IlDNEtJYBXGfifAkr0H4q+zrgWuuWoyRH5MilH6EOZ5iQ7avRakKP3S2YKOGPAZECHIgrorZi8kZZ0x7/o+AoTRAM6FHGL/imQyZ38DZmci+4OauRPXGQjKx1/RoTZgBQUXaN/AMQInPgxpuIBQzxgIasE6OiTJpNLaRRzr01mrYBGcyeX8qmATJvMKgGWeIA1HmCNB1jzDaYDxDGy/OJYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/platform.png
// module id = Dtgb
// module chunks = 16